// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as LogUtils from "../../utils/LogUtils.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as FirebaseError from "../../backend/FirebaseError.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as JsxRuntime from "react/jsx-runtime";

function get(state, field) {
  switch (field) {
    case "NewPassword" :
      return state.newPassword;
    case "NewPasswordConfirmation" :
      return state.newPasswordConfirmation;
    case "OldPassword" :
      return state.oldPassword;
  }
}

function set(state, field, value) {
  switch (field) {
    case "NewPassword" :
      return {
        newPassword: value,
        newPasswordConfirmation: state.newPasswordConfirmation,
        oldPassword: state.oldPassword
      };
    case "NewPasswordConfirmation" :
      return {
        newPassword: state.newPassword,
        newPasswordConfirmation: value,
        oldPassword: state.oldPassword
      };
    case "OldPassword" :
      return {
        newPassword: state.newPassword,
        newPasswordConfirmation: state.newPasswordConfirmation,
        oldPassword: value
      };
  }
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function ChangePassword(props) {
  let onSubmit = props.onSubmit;
  let form = Form.use({
    newPassword: "",
    newPasswordConfirmation: "",
    oldPassword: ""
  }, Validators$1.schema([
    Validators$1.required("OldPassword"),
    Validators$1.required("NewPassword"),
    Validators$1.password("NewPassword"),
    Validators$1.matchField("NewPassword", "Hesla se neshodují", "NewPasswordConfirmation")
  ]), param => {
    let raiseSubmitFailed = param.raiseSubmitFailed;
    let state = param.state;
    let send = param.send;
    let match = state.values;
    Stdlib_Promise.$$catch(onSubmit({
      oldPassword: match.oldPassword,
      newPassword: match.newPassword
    }), error => {
      let match = FirebaseError.toFirebaseError(error);
      if (match.RE_EXN_ID === FirebaseError.InvalidPassword) {
        let newFieldsState = state.fieldsState.map(tuple => {
          let field = tuple[0];
          if (Primitive_object.notequal(field, {
              TAG: "Field",
              _0: "OldPassword"
            })) {
            return tuple;
          } else {
            return [
              field,
              {
                TAG: "Error",
                _0: `Nesprávné heslo`
              }
            ];
          }
        });
        send({
          TAG: "SetFieldsState",
          _0: newFieldsState
        });
      } else {
        let exn = Stdlib_Option.getOrThrow(Stdlib_JsExn.fromException(error), undefined);
        LogUtils.captureException(exn);
        let msg = Stdlib_JsExn.message(exn);
        let errorMessage = msg !== undefined ? `Chyba: ` + msg : "Neznámá chyba";
        raiseSubmitFailed(errorMessage);
      }
      return Promise.resolve();
    });
  }, undefined, undefined, "OnDemand", undefined);
  let submitting = form.state.formState === "Submitting";
  let maybeErrorMessage = form.state.formState;
  let tmp;
  if (typeof maybeErrorMessage !== "object") {
    tmp = null;
  } else {
    let maybeErrorMessage$1 = maybeErrorMessage._0;
    tmp = <p
      className={Styles.messageBar.variantDanger}
    >
      {maybeErrorMessage$1 !== undefined ? maybeErrorMessage$1 : "Neznámá chyba"}
    </p>;
  }
  return <DialogForm.make
    formId={"change_password"}
    heading={"Změna hesla"}
    onDismiss={props.onDismiss}
    visible={true}
  >
    <Form.Provider.make
      value={form}
    >
      <form
        className={Styles.stack.base}
        id={"change_password"}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={`reset ` + Styles.fieldset.grid}
          disabled={submitting}
        >
          <Form.Field.make
            field={"OldPassword"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"oldPassword"}
              inputSlot={<input
                type={"password"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={`Nynější heslo`}
            />}
          />
          <Form.Field.make
            field={"NewPassword"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"newPassword"}
              inputSlot={<input
                type={"password"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={`Nové heslo`}
            />}
          />
          <Form.Field.make
            field={"NewPasswordConfirmation"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"newPasswordConfirmation"}
              inputSlot={<input
                type={"password"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={`Heslo znovu`}
            />}
          />
        </fieldset>
        {tmp}
      </form>
    </Form.Provider.make>
  </DialogForm.make>;
}

let make = ChangePassword;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
